var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible",
        },
      ],
      staticClass: "results-container",
      attrs: { disabled: _vm.request },
    },
    [
      _vm.request
        ? _c("span", {
            staticClass: "fa fa-spinner fa-spin searchIndicator",
            staticStyle: { position: "absolute", left: "50%", top: "15px" },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "crumbs-totals" },
        [
          _c(
            "ol",
            { staticClass: "breadcrumb resultscrumb" },
            _vm._l(_vm.breadCrumbs, function (crumb, index) {
              return _c(
                "li",
                {
                  key: index,
                  class: { active: crumb.active || !!_vm.request },
                },
                [
                  !crumb.active && !_vm.request
                    ? _c(
                        "a",
                        {
                          class: _vm.request ? "disabled" : undefined,
                          attrs: {
                            role: "button",
                            title: crumb.title,
                            disabled: _vm.request,
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              !_vm.request && crumb.onClick
                                ? crumb.onClick()
                                : undefined
                            },
                          },
                        },
                        [_vm._v(_vm._s(crumb.label))]
                      )
                    : [_vm._v(_vm._s(crumb.label))],
                ],
                2
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.results
            ? _c("Totals", {
                staticClass: "result-totals",
                attrs: {
                  initialResults: _vm.results,
                  type: _vm.type,
                  indexId: _vm.indexId,
                },
                on: {
                  update: function ($event) {
                    _vm.paginationResults = $event
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.resultsHaveData
        ? [
            _c(
              _vm.resultComponentName,
              _vm._b(
                {
                  tag: "component",
                  on: {
                    sort: function ($event) {
                      _vm.sort = $event
                    },
                    viewgroup: function ($event) {
                      _vm.originalGroupBySettings = {
                        page: _vm.page,
                        sort: _vm.sort,
                      }
                      _vm.log(_vm.page, _vm.sort)
                      _vm.viewGroup = $event.id
                      _vm._viewGroupName = $event.displayName
                    },
                  },
                },
                "component",
                _vm.resultComponentData,
                false
              ),
              [
                _c("GroupBy", {
                  attrs: {
                    slot: "groupBy",
                    type: _vm.type,
                    disabled: !!_vm.request,
                    originalGroupBySettings: _vm.originalGroupBySettings,
                  },
                  on: { viewgroupLeave: _vm.leaveViewgroup },
                  slot: "groupBy",
                }),
                _vm._v(" "),
                _c("Pagination", {
                  staticStyle: { display: "block", margin: "10px 0" },
                  attrs: {
                    slot: "pagination",
                    page: _vm.pagination.shownPage,
                    maxPage: _vm.pagination.maxShownPage,
                    disabled: !!_vm.request,
                  },
                  on: {
                    change: function ($event) {
                      _vm.page = $event
                    },
                  },
                  slot: "pagination",
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("hr"),
          ]
        : _vm.results
        ? _c("div", { staticClass: "no-results-found" }, [
            _vm._v("No results found."),
          ])
        : !_vm.valid
        ? _c("div", { staticClass: "no-results-found" }, [
            _vm._v(
              "\n\t\tThis view is inactive because no search criteria for words were specified.\n\t"
            ),
          ])
        : _vm.error != null
        ? _c("div", { staticClass: "no-results-found" }, [
            _c("span", {
              staticClass: "fa fa-exclamation-triangle text-danger",
            }),
            _c("br"),
            _vm._v(" "),
            _c("span", { domProps: { innerHTML: _vm._s(_vm.error) } }),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-default",
                attrs: {
                  type: "button",
                  title: "Try again with current search settings",
                },
                on: {
                  click: function ($event) {
                    return _vm.markDirty()
                  },
                },
              },
              [_vm._v("Try again")]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.resultsHaveData,
              expression: "resultsHaveData",
            },
          ],
          staticClass: "text-right",
        },
        [
          _c("SelectPicker", {
            attrs: {
              "data-class": "btn-sm btn-default",
              placeholder: "Sort by...",
              "data-menu-width": "grow",
              allowHtml: "",
              hideDisabled: "",
              allowUnknownValues: "",
              right: "",
              searchable:
                _vm.sortOptions.flatMap(function (o) {
                  return o.options && !o.disabled
                    ? o.options.filter(function (opt) {
                        return !opt.disabled
                      })
                    : o
                }).length > 12,
              options: _vm.sortOptions,
              disabled: !!_vm.request,
            },
            model: {
              value: _vm.sort,
              callback: function ($$v) {
                _vm.sort = $$v
              },
              expression: "sort",
            },
          }),
          _vm._v(" "),
          _vm.isDocs && _vm.resultsHaveHits
            ? _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-sm",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      _vm.showDocumentHits = !_vm.showDocumentHits
                    },
                  },
                },
                [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(_vm.showDocumentHits ? "Hide Hits" : "Show Hits") +
                      "\n\t\t"
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isHits
            ? _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-sm",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      _vm.showTitles = !_vm.showTitles
                    },
                  },
                },
                [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(_vm.showTitles ? "Hide" : "Show") +
                      " Titles\n\t\t"
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.results && _vm.exportEnabled
            ? _c("div", { staticClass: "btn-group" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-default btn-sm",
                    attrs: {
                      type: "button",
                      disabled:
                        _vm.downloadInProgress ||
                        !_vm.resultsHaveData ||
                        !!_vm.request,
                      title: _vm.downloadInProgress
                        ? "Downloading..."
                        : "Export results as a CSV file",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.downloadCsv(false)
                      },
                    },
                  },
                  [
                    _vm.downloadInProgress
                      ? [
                          _vm._v(" "),
                          _c("span", { staticClass: "fa fa-spinner fa-spin" }),
                          _vm._v(" "),
                        ]
                      : _vm._e(),
                    _vm._v("Export\n\t\t\t"),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-default btn-sm",
                    attrs: {
                      type: "button",
                      disabled:
                        _vm.downloadInProgress ||
                        !_vm.resultsHaveData ||
                        !!_vm.request,
                      title: _vm.downloadInProgress
                        ? "Downloading..."
                        : "Export Results as a CSV file for use with Excel",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.downloadCsv(true)
                      },
                    },
                  },
                  [
                    _vm.downloadInProgress
                      ? [
                          _vm._v(" "),
                          _c("span", { staticClass: "fa fa-spinner fa-spin" }),
                          _vm._v(" "),
                        ]
                      : _vm._e(),
                    _vm._v("Export for Excel\n\t\t\t"),
                  ],
                  2
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("Debug", [
        _c("div", [
          _c("div", [_vm._v("BlackLab response: ")]),
          _vm._v(" "),
          _vm.results
            ? _c("pre", [
                _vm._v(
                  _vm._s(JSON.stringify(_vm.results.summary, undefined, 2))
                ),
              ])
            : _vm._e(),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }